const DefaultClassProps = (function(){
    class Test {}
    return Object.getOwnPropertyNames(Test);
})();

const DefaultClassProtoProps = (function(){
    class Test {}
    return Object.getOwnPropertyNames(Test.prototype);
})();

// The mixin utility, as currently implemented,
// uses the first argument as a direct parent, and
// mixes in the directly assigned methods and properties
// from rest of the arguments. That is, the util can
// currently mix only the methods and properties that
// are directly assigned in given mixin.
export default function mixin(Parent, ...mixins) {
    class Mixed extends Parent { }

    for (let mixin of mixins) {
        for (let prop of Object.getOwnPropertyNames(mixin)) {
            if (DefaultClassProps.indexOf(prop) == -1) {
                Object.defineProperty(Mixed, prop, Object.getOwnPropertyDescriptor(mixin, prop));
            }
        }

        for (let prop of Object.getOwnPropertyNames(mixin.prototype)) {
            if (DefaultClassProtoProps.indexOf(prop) == -1) {
                let desc = Object.getOwnPropertyDescriptor(mixin.prototype, prop);
                Object.defineProperty(Mixed.prototype, prop, desc);
            }
        }
    }

    return Mixed;
}


// WEBPACK FOOTER //
// ./src/lib/mixin.js